/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

export enum SigningActionType {
  SIGN = 'SIGN',
  VIEW = 'VIEW',
  DONE = 'DONE',
  WAIT_FOR_SIGNING_TO_START = 'WAIT_FOR_SIGNING_TO_START',
  /**
   * After a document is fully signed, we need to wait for the updated PDF to be available
   * before we can take further action (ex: notarize the doc). To handle this, we send the
   * 'WAIT_FOR_POST_SIGN_PROCESSING' action until we receive the Kafka event telling us that
   * the updated PDF is available.
   */
  WAIT_FOR_POST_SIGN_PROCESSING = 'WAIT_FOR_POST_SIGN_PROCESSING',
  REVIEW = 'REVIEW',
}
